/** @format */

import { ApplicationRef, enableProdMode } from '@angular/core';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
	bootstrapApplication(AppComponent, appConfig)
		.then((app) => {
			if (!environment.production) {
				const applicationRef = app.injector.get(ApplicationRef);
				const appComponent = applicationRef.components[0];
				enableDebugTools(appComponent);
			}
		})
		.catch((error) =>
			console.error(
				`APPLICATION_ERROR:BOOTSTRAP_ERROR: ${JSON.stringify(error, ['message', 'arguments', 'type', 'name'])}`
			)
		);
});
